import assign from 'object-assign';

import constants from '../utils/constants.js';

import GenericStore from './GenericStore.js';
import databaseUtils from './databaseUtils.js';

const {GAME_LENGTH} = constants;

let highScores = [];
let currentScore = {};
let practice = 'name';

// Score values are in number of seconds

function getKey() {
  if (practice === 'name') {
    return `highScores-${GAME_LENGTH}`;
  }
  return `highScores-pos-${GAME_LENGTH}`
}

// This function is fire-and-forget. The store calls this function, which
// returns a promise, but then never waits for the promise to resolve. The
// application continues while the writing is in progress.
async function writeHighScores() {
  const database = await databaseUtils.getDatabase();
  await databaseUtils.writeToDatabase(database, getKey(), highScores);
}

// This function is called at app startup. It will read the high scores to
// be available when needed.
async function readHighScores() {
  const database = await databaseUtils.getDatabase();
  const data = await databaseUtils.readFromDatabase(database, getKey());
  highScores = data;
}

const PersistentStore = assign({}, GenericStore, {
  addScore: function(newScore) {
    currentScore = {
      score: newScore,
      time: Date.now()
    };

    const newHigh = [];
    let count = 0;
    while (count < 10 && highScores[count]?.score < newScore) {
      newHigh[count] = highScores[count];
      count++;
    }
    if (count < 10) {
      newHigh[count] = currentScore;
      count++;
    }
    while (count < 10) {
      newHigh[count] = highScores[count - 1];
      count++;
    }

    highScores = newHigh;

    writeHighScores();

    PersistentStore.emitChange();
  },

  getScore: function() {
    return currentScore;
  },

  getHighScores: function() {
    return highScores;
  },

  setPractice: function(value) {
    practice = value;
    PersistentStore.emitChange();
  }
});

readHighScores();

export default PersistentStore;
